module.exports = __webpack_public_path__ + "static/boredom_spanish-d273a1574e3ca76337adf01675ef9bbe.png";